import {getStationCode} from "../../network/NetworkUtil";
import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {logOperationalMetric} from "../../util/Util";
const metricProcessName = "SCC_INDUCT";

/**
 * API call for fetching induct process details
 * @param dispatcher
 */
export function fetchInductProcessData(dispatcher) {
    const request = {
        nodeId: getStationCode()
    };
    getInductProcessDetails(dispatcher, request)
}

function fetchInductProcessDetailsAPIGatewayRequest(request) {
    return {
        resourcePath: "/ivs/getInductProcessDetails",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

async function getInductProcessDetails(dispatcher, request) {
    const args = fetchInductProcessDetailsAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getInductProcessDetails", true);
            let inductProcessData = result.data;
            dispatcher({type: "FETCH_INDUCT_PROCESS_DATA_SUCCESS", payload: {inductProcessData}});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getInductProcessDetails", false);
            dispatchFailure(result.errorResponse, dispatcher)
        }
    });
}

function dispatchFailure(errorResponse, dispatcher) {
    let message = "generic.error";
    if(errorResponse && errorResponse.errorMessage) {
        message = errorResponse.errorMessage
    }
    dispatcher({type: "API_FAILURE", payload: {message}});
}

/**
 * API call for updating induct process details
 * @param nodeInductProcessDetailsRequest
 * @param dispatcher
 */
export function setInductProcessDetails(nodeInductProcessDetailsRequest, dispatcher) {
    const request = {
        nodeId: getStationCode(),
        nodeInductProcessDetails: nodeInductProcessDetailsRequest,
    };
    updateInductProcessDetails(dispatcher, request)
}

function updateInductProcessDetailsAPIGatewayRequest(request) {
    return {
        resourcePath: "/ivs/setInductProcessDetails",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

async function updateInductProcessDetails(dispatcher, request) {
    const args = updateInductProcessDetailsAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "setInductProcessDetails", true);
            dispatcher({type: "SET_INDUCT_PROCESS_DATA_SUCCESS"});
        } else {
            logOperationalMetric(startTime, metricProcessName, "setInductProcessDetails", false);
            dispatchFailure(result.errorResponse, dispatcher)
        }
    });
}




// WEBPACK FOOTER //
// ./src/components/inductManagement/network/InductManagementNetworkAPI.js